module.exports = __webpack_public_path__ + "img/MN.3e1d28e7.svg";